import Swal from 'sweetalert2';


export const alert = (title, message, type, textButton) => {
    Swal.fire({
        title: title,
        text: message,
        icon: type,
        confirmButtonText: textButton
    })
}

export const removeAccentsAndSpaces = (str) => {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-");
};